module.exports = __webpack_public_path__ + "assets/img/benefit-2.6dc30993.svg";